import React, { memo } from 'react';

import config from '../../../config';
import Button from '../../helpers/Button';
import { AppPage } from '../../AppPage';
import { GridCard } from '../../helpers/GridCard';
import { CompanyTradeGroupsTable } from './CompanyTradeGroupsTable';

import style from './style.module.css';

const TABLE_TITLE = 'All Trade Groups (Trade Shows, Industry Associations, List Sources)';

const CompanyTradeGroupsComponent = ({ onDoubleClickRow, onAdd, data, onChange }) => {
  const columnDefs = config.tables.getIn(['companyTradeGroups', 'columnDefs']);

  const toolbar = (
    <div className={style.toolbar}>
      <Button onClick={onAdd}>
        <i aria-hidden="true" className="fa fa-plus" /> Add Trade Group
      </Button>
    </div>
  );

  return (
    <AppPage overline="Company" title="Trade Groups" toolbar={toolbar}>
      <GridCard className={style.grid} title={TABLE_TITLE} dense>
        <CompanyTradeGroupsTable
          columnDefs={columnDefs}
          data={data}
          onChange={onChange}
          onDoubleClickRow={onDoubleClickRow}
        />
      </GridCard>
    </AppPage>
  );
};

/** Company trade groups component. */
export const CompanyTradeGroups = memo(CompanyTradeGroupsComponent);
